
import React from 'react';

import ReactDOM from 'react-dom';
import { Layout } from 'element-react';
import { Menu, Dropdown, Button, message, Tooltip } from '@jd/find-react';
import FeasComponents from '../render/FeasComponents.js'
 

import KeeVue from '../base/KeeVue.js'
 
export default class FsDropdown extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),
			menus:[]

		}

	}

	componentDidMount() {
		var that = this;
		this.registComponent();
		
		this.showMenu();

	}
	
	showMenu=()=>{
		
		//alert(JSON.stringify(this.props.component.cp.menuJson));
		if(this.props.component.cp.menuJson)
		{
			this.state.menus = JSON.parse(this.props.component.cp.menuJson);
			
			for(var i=0;i<this.state.menus.length;i++)
			{
				this.state.menus[i].id=this.getRandString();
			}
		}
		else
		{
			this.state.menus = [];
		}
		
		
		this.refresh();
		
	}
	
	componentWillReceiveProps(nextProps){
		console.log("dropdown refresh ");
		this.showMenu();
	}

	onCommand=(cmdName, item, po, thisForm, parentForm)=> {
		this.$emit("command", cmdName, item, po, thisForm, parentForm);
	}
	onChanged=(ret)=> {
		this.$emit("changed", ret);
	}

	handleMenuClick=(e)=>{
		console.log(e);
		
		if(this.props.component.id)
		{
			this.sendPageEvent("select",e,this.props.po);
		}
		else
		{
			 
		}
		
		
	}

 
	render() {
		
		var size = this.props.component.cp.size;
		
		if(size=='mini')
		{
			size='small';
		}
		else
		if(size=='small'||size=='normal')
		{
			size='defalut';
		}
		else
		{
			size='large';
		}
	 
		var style = JSON.parse(JSON.stringify(this.props.component.style));
		// 强制col的display为block
	 
		
		var menu=<Menu onClick={this.handleMenuClick}>
		{
			this.state.menus.map((item,index)=>{
				return <Menu.Item key={item.code}  >
				  {item.title}
				</Menu.Item>
			})
		} 
		</Menu>
		  
		return (

			<div style={style}>
				<Dropdown overlay={menu}>
				    <Button
					size={size}
					type={this.props.component.cp.type=='text'?'link':this.props.component.cp.type}
					  
					shape={this.props.component.cp.shape}
					block={this.props.component.cp.block}
					>
				      {this.props.component.cp.title}  
					  
					  {
					  	this.props.component.cp.icon&&<i className={`${ this.props.component.cp.icon}`} ></i>
					  }
					  
				    </Button>
				</Dropdown>

			</div>
			
			
				
				

		);
	}
}
